import React, { Fragment } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, Input, CardBody, FormGroup } from "reactstrap"
// import { Filter, DefaultColumnFilter } from "./filters"
import { DefaultColumnFilter } from "components/Common/filters"
import JobListGlobalFilter from "components/Common/GlobalSearchFilter"
import { useEffect } from "react"
import { useState } from "react"

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  isJobListGlobalFilter,
  filterData,
  value,
  setValue,
}) {
  const count = preGlobalFilteredRows.length
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
    filterData(value)
  }, 200)

  return (
    <React.Fragment>
      <Col md={12}>
        <div className="search-box w-full d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Search this table
              </span>
              <input
                onChange={e => {
                  setValue(e.target.value)
                  onChange(e.target.value)
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={"Search..."}
                value={value || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </Col>
      {isJobListGlobalFilter && <JobListGlobalFilter />}
    </React.Fragment>
  )
}


const SalesTable = ({
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  dateValue,
  writeDataToExcel,
  totalAmount,
  TotalDiscount,
  isCreateProduct,
  isAddUserList,
  handleUserClick,
  customPageSize,
  className,
  isCategoryList,
  handleCategoryClick,
  isCreateBooking,
  handleBookingClicks,
  isColorList,
  handleColorClick,
  isSubscriptionList,
  handleSubscriptionClick,
  filterData,
  pagePerSize,
  isLoading,
  TotalRecords,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      manualPagination: true,
      initialState: {
        // pageIndex: 0,
        pageSize: customPageSize,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useExpanded,
    usePagination
  )
  const [pageIndex, setpageIndex] = useState(1)

  const handlesort = column => { }

  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? "🔽" : "🔼") : ""
  }

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
  }

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0
    gotoPage(page)
  }

  const [value, setValue] = React.useState()

  if (pagePerSize) {
    useEffect(() => {
      pagePerSize(pageSize, pageIndex, value)
    }, [pageSize, value, pageIndex])
  }

  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [deliveryDate, setDeliveryDate] = useState(new Date().toISOString().slice(0, 10))
  const [returnDate, setReturnDate] = useState(new Date().toISOString().slice(0, 10))

  if (dateValue) {
    dateValue(deliveryDate, returnDate)
  }

  const margin = {
    marginTop: isMobile ? "8px" : "",
  }

  return (
    <Fragment>
      <Row className="">
        <Col md="4" style={{ marginTop: "20px" }}>
          <Row>
            <Col md="6" className="table-header">
              <select
                className="form-select"
                value={pageSize}
                onChange={onChangeInSelect}
              >
                {[10, 20, 30, 40, 50].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </Col>
            <Col md="6" className="table-header" style={margin}>
              {isGlobalFilter && (
                <GlobalFilter
                  preGlobalFilteredRows={preGlobalFilteredRows}
                  globalFilter={state.globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  isJobListGlobalFilter={isJobListGlobalFilter}
                  filterData={filterData}
                  value={value}
                  setValue={setValue}
                />
              )}
            </Col>
            {/* <Col md="4" className="table-header">
              <select
                className="form-select"
                value={statusChange}
                onChange={e => setStatusChange(e.target.value)}
              >
                <option value={""}>Status</option>
                <option value={"Booked"}>Booked</option>
                <option value={"Delivered"}>Delivered</option>
                <option value={"Return"}>Return</option>
                <option value={"Cancel"}>Cancel</option>
              </select>
            </Col> */}
          </Row>
        </Col>
        <Col md={2} className="table-header" style={margin}>
          {isGlobalFilter && (
            <div>
              <span className=" me-2">From</span>

              <Input
                name="form"
                type="date"
                dateFormat="DD/M/YYYY"
                className="form-control"
                value={deliveryDate}
                onChange={e => setDeliveryDate(e.target.value)}
              />
            </div>
          )}
        </Col>
        <Col md={2} className="table-header mb-2" style={margin} >
          {isGlobalFilter && (
            <div>
              <span className=" me-2">To</span>

              <Input
                name="form"
                type="date"
                min={deliveryDate}
                dateFormat="DD/M/YYYY"
                className="form-control"
                value={returnDate}
                onChange={e => setReturnDate(e.target.value)}
              />
            </div>
          )}
        </Col>
        <Col md={1} className="table-header mb-2" style={{ marginTop: "20px", margin }} >
          <Row>
            <Col md="12" className="table-header">
              {data.length > 0 ? (<button
                type="button"
                className="btn btn-primary  btn-label"
                onClick={writeDataToExcel}
              >
                Export <i className="far fa-file-excel label-icon"></i>
              </button>) : (<button
                type="button"
                className="btn  btn-primary  btn-label"
                style={{ cursor: "not-allowed" }}
              >
                Export <i className="far fa-file-excel label-icon"></i>
              </button>)}


            </Col>
          </Row>
        </Col>
        <Col md="3" style={{ marginTop: "20px", textAlign: "end" }}>
          {isGlobalFilter && (
            <div style={{ color: "#0F6E25", fontSize: "15px" }}>
               Total Amount:  <i className="mdi mdi-currency-inr"></i>{totalAmount.toFixed(2)} <br />
               Total Discount:  <i className="mdi mdi-currency-inr"></i>{TotalDiscount.toFixed(2)}
            </div>
          )}
        </Col>
      </Row>


      <div className="table-responsive react-table">
        <Table bordered hover {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    onClick={() => {
                      handlesort(column)
                    }}
                    {...column.getHeaderProps({
                      style: {
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth,
                        width: column.width,
                      },
                    })}
                  >
                    <div className={`mb-0`}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {page.length ? (
            <tbody {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr>
                      {row.cells.map(cell => {
                        return (
                          <td
                            key={cell.id}
                            className="text-nowrap"
                            {...cell.getCellProps({
                              style: {
                                minWidth: cell.minWidth,
                                maxWidth: cell.maxWidth,
                                width: cell.width,
                              },
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  </Fragment>
                )
              })}
            </tbody>
          ) : (
            <tbody
              style={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                height: "40px",
              }}
            >
              <tr>
                <td colSpan={headerGroups[0].headers.length}>
                  {isLoading ? "Loading..." : "No Record Found"}
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex - 1)}
              disabled={pageIndex == 1}
            >
              {"<<"}
            </Button>
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page{" "}
          <strong>
            {pageIndex} of {Math.ceil(TotalRecords / pageSize)}
          </strong>
        </Col>
        <Col className="col-md-auto">
          <Input
            type="text"
            min={1}
            style={{ width: 70 }}
            max={pageOptions.length}
            defaultValue={pageIndex}
            onChange={onChangeInInput}
            value={pageIndex}
            disabled
          />
        </Col>

        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex + 1)}
              disabled={pageIndex == (pageIndex == 1 && TotalRecords == 0 ? Math.ceil(TotalRecords / pageSize) + 1 : Math.ceil(TotalRecords / pageSize))}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  )
}

SalesTable.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default SalesTable
